import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'

import { cn } from '../../lib/utils'

export interface ListSwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  offLabel?: string
  onLabel?: string
}

const ListSwitch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  ListSwitchProps
>(({ className, offLabel = 'off', onLabel = 'on', ...props }, ref) => (
  <span className="inline-flex items-center gap-2.5 select-none">
    <span
      aria-hidden
      className="font-mono text-[9px] tracking-[0.2em] uppercase text-muted-foreground data-[on=false]:text-foreground transition-colors"
      data-on={props.checked === true ? 'true' : 'false'}
    >
      {offLabel}
    </span>
    <SwitchPrimitives.Root
      ref={ref}
      className={cn(
        'group relative inline-flex h-4 w-9 shrink-0 cursor-pointer items-center',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <span
        aria-hidden
        className="absolute left-0 right-0 top-1/2 h-px -translate-y-1/2 bg-border group-data-[state=checked]:bg-primary/50 transition-colors"
      />
      <SwitchPrimitives.Thumb
        className={cn(
          'pointer-events-none block h-3 w-3 rounded-full border bg-card transition-all',
          'border-border shadow-sm',
          'translate-x-0.5 rtl:-translate-x-0.5',
          'data-[state=checked]:translate-x-[1.375rem] rtl:data-[state=checked]:-translate-x-[1.375rem]',
          'data-[state=checked]:bg-primary data-[state=checked]:border-primary',
          'data-[state=checked]:shadow-[0_0_10px_hsl(var(--color-primary)/0.45)]',
        )}
      />
    </SwitchPrimitives.Root>
    <span
      aria-hidden
      className="font-mono text-[9px] tracking-[0.2em] uppercase text-muted-foreground data-[on=true]:text-primary transition-colors"
      data-on={props.checked === true ? 'true' : 'false'}
    >
      {onLabel}
    </span>
  </span>
))
ListSwitch.displayName = 'ListSwitch'

export { ListSwitch }
